<div class="vat-verification-dialog">
  <!-- Dialog Header -->
  <div mat-dialog-title class="dialog-header">
    <mat-icon class="warning-icon">warning</mat-icon>
    <h2>Tax Compliance Check</h2>
  </div>

  <!-- Dialog Content -->
  <div mat-dialog-content class="dialog-content">
    <p class="message">
      Your VAT/tax details are missing or invalid. To continue, please update your account information. 
      You can also choose to opt out if you don't require VAT processing.
    </p>
    
    <div class="info-section">
      <span class="info-text">
        Updating your tax details ensures compliance and accurate billing.
      </span>
    </div>
  </div>

  <!-- Dialog Actions -->
  <div mat-dialog-actions class="dialog-actions">
    <button 
      mat-button 
      class="opt-out-button" 
      (click)="onOptOut()">
      Opt Out
    </button>
    
    <button 
      mat-raised-button 
      color="primary" 
      class="update-button"
      (click)="onUpdateDetails()">
      <mat-icon>edit</mat-icon>
      Update Account Info
    </button>
  </div>
</div>
